module.exports = __webpack_public_path__ + "img/mt-b.c3508cd8.png";